import {logger} from "@services/logger/logger.service";

export function fallbackCopyImageToClipboard(htmlString: string) {
    let copied = false;

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    const img = doc.querySelector('img');

    if (!img) {
        throw new Error('Failed to create html img from htmlString');
    }

    const textArea = document.createElement('div')
    textArea.contentEditable = 'true'
    textArea.appendChild(img)
    document.body.appendChild(textArea)
    textArea.focus();
    selectElement(textArea);

    try {
        copied = document.execCommand('copy');
    }
    catch (err) {
        logger.error(`fallbackCopyImageToClipboard failed:`, err);
    }
    finally {
        document.body.removeChild(textArea);
    }

    return copied;
}


export function selectElement(element: HTMLElement) {
    const doc = document
    let range = undefined;
    if ('createTextRange' in doc.body && typeof doc.body.createTextRange === 'function') {
        range = doc.body.createTextRange();
        range.moveToElementText(element);
        range.select();
    } else if (window.getSelection) {
        const selection = window.getSelection();
        range = doc.createRange();
        range.selectNodeContents(element);
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
}
